import apiClient from "./ApiService";
import { PATH_ACCOUNTS_BY_CIF_BANK } from "../config/env";

export const getAccountsByCif = async (idCif) => {
    let url = PATH_ACCOUNTS_BY_CIF_BANK + idCif;
    return await apiClient.get(url);
}

export default getAccountsByCif;